export const ASSINATURA_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-6 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            left: "flex items-center gap-3",
            iconWrapper: "w-11 h-11 rounded-2xl bg-violet-100 flex items-center justify-center",
            icon: "text-violet-600",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-0.5",
        },
    },
    tabs: {
        list: "bg-gray-100/80 rounded-xl p-1 gap-1",
        trigger: "rounded-lg text-sm font-medium data-[state=active]:bg-white data-[state=active]:text-[#7C3AED] data-[state=active]:shadow-sm px-4 py-2 transition-all",
        content: "mt-6",
    },
    subscription: {
        statusCard: "bg-white rounded-xl border border-gray-100 p-6",
        statusHeader: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
        statusLeft: "flex flex-col gap-1",
        statusLabel: "text-xs font-semibold uppercase tracking-wider text-gray-500",
        statusValue: "text-lg font-bold text-gray-900",
        statusBadge: "text-xs font-medium flex items-center gap-1.5 px-2.5 py-1 rounded-full",
        statusActive: "bg-green-50 text-green-700 border border-green-200",
        statusTrial: "bg-amber-50 text-amber-700 border border-amber-200",
        statusInactive: "bg-red-50 text-red-700 border border-red-200",
        dot: "w-1.5 h-1.5 rounded-full",
        dotActive: "bg-green-500",
        dotTrial: "bg-amber-500",
        dotInactive: "bg-red-500",
        priceContainer: "flex items-baseline gap-1 mt-2",
        price: "text-3xl font-bold text-gray-900",
        pricePeriod: "text-sm text-gray-500",
        dateInfo: "text-sm text-gray-500 mt-1",
    },
    plan: {
        card: "bg-white rounded-xl border border-gray-100 p-6",
        header: "flex items-center justify-between mb-4",
        headerLeft: "flex items-center gap-3",
        iconWrapper: "w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50",
        icon: "text-violet-600",
        title: "text-base font-bold text-gray-900",
        subtitle: "text-xs text-gray-500",
        badge: "text-xs font-medium flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200",
        actions: "flex items-center gap-2 mt-4",
        btnPrimary: "flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95",
        btnSecondary: "flex items-center gap-2 px-4 py-2.5 bg-white hover:bg-gray-50 text-gray-700 text-sm font-medium rounded-xl transition-all border border-gray-200",
        note: "flex items-start gap-2 mt-4 p-3 bg-amber-50/50 rounded-xl border border-amber-100",
        noteIcon: "text-amber-500 mt-0.5 flex-shrink-0",
        noteText: "text-xs text-amber-700",
    },
    addons: {
        card: "bg-white rounded-xl border border-gray-100 p-6",
        header: "flex items-center gap-3 mb-4",
        iconWrapper: "w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50",
        icon: "text-violet-600",
        title: "text-base font-bold text-gray-900",
        list: "flex flex-col gap-3",
        item: "flex items-center justify-between p-3 rounded-xl border border-gray-100 hover:border-violet-200 transition-all",
        itemLeft: "flex items-center gap-3",
        itemIcon: "w-8 h-8 rounded-lg flex items-center justify-center bg-gray-50",
        itemName: "text-sm font-medium text-gray-900",
        itemDesc: "text-xs text-gray-500",
        itemBadge: "text-xs font-medium flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200",
    },
    placeholder: {
        container: "flex flex-col items-center justify-center py-16",
        iconWrapper: "w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mb-4",
        icon: "text-gray-400",
        title: "text-base font-semibold text-gray-900 mb-1",
        subtitle: "text-sm text-gray-500",
    },
};
